module.exports = __webpack_public_path__ + "img/group.27f25417.png";